import React from 'react'
import { Breadcrumb } from 'antd'
import PropTypes from 'prop-types'

import RequestBody from './RequestBody'

/**
 * The routed car-request page. A thin shell around RequestBody, which the list's quick-view modal
 * renders too — so the page and the modal cannot drift apart.
 */
const Detail = props => (
  <div className="container-fluid">
    <div className="row">
      <div className="col-md-12">
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            <span>Home</span>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="/car-requests">Car Requests</Breadcrumb.Item>
          <Breadcrumb.Item>Request</Breadcrumb.Item>
        </Breadcrumb>
        <br />
        <RequestBody id={props.match.params.id} mode="page" />
      </div>
    </div>
  </div>
)

Detail.propTypes = {
  match: PropTypes.object
}

export default Detail
